<template>
  <div class="browse-vechicles-img" :class="[brand === 'mazda' ? 'mazda-styles' : '']" role="region">
    <div class="container vehicle-browse-ajax">
      <div class="browse-step" id="first-step">
        <h2 class="text-center step-instructions"></h2>
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-6" v-for="(button, index) in images.browseButtons" :key="index">
            <a href="#" data-category="Home Page Actions">
              <img class="img-responsive center-block" :src="[brand === 'mazda' ? mazdaImages[index] : button]" alt="Shop">
              <span v-if="brand === 'mazda'">{{mazdaTitles[index]}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      mazdaTitles: ['Special Offers', 'Get Financing', 'Schedule a Test Drive', 'Get Directions'],
      mazdaImages: [require("../../static/images/common-icons/icon-specials.png"), require("../../static/images/common-icons/icon-financing.png"), require("../../static/images/common-icons/icon-testdrive.png"), require("../../static/images/common-icons/icon-location.png")]
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.browse-vechicles-img .vehicle-browse-ajax img {
  max-height: 65px;
  margin: auto;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  transform: perspective(1px) translateZ(0);
  -webkit-transition-property: transform;
  transition-property: transform;
}
.browse-vechicles-img .vehicle-browse-ajax img:hover {
  transform: scale(1.1);
}
.browse-vechicles-img .step-instructions {
  display: none;
}
.browse-vechicles-img {
  padding: 15px 0;
  background-color: #fff;
}
.browse-vechicles-img .col-md-3.col-sm-6.col-xs-6 {
  margin: 15px auto;
}
.browse-vechicles-img .col-md-3.col-sm-6.col-xs-6:last-of-type {
  border-right: none;
  border-bottom: none;
}
.mazda-styles.browse-vechicles-img .container {
  width: 100%;
  max-width: 100%;
  padding-left: 24px;
  padding-right: 24px;
}
.mazda-styles.browse-vechicles-img .row {
  margin: auto;
}
.mazda-styles.browse-vechicles-img .col-md-3.col-sm-6.col-xs-6 {
  border: none !important;
  padding-left: 5px;
  padding-right: 5px;
  margin: auto;
}
.mazda-styles.browse-vechicles-img a {
  background: #f5f5f5;
  color: #101010;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-decoration: none;
  font-size: 16px !important;
  display: flex;
  width: 100%;
  height: 125px;
  margin: 5px auto;
  text-align: center;
  flex-direction: column;
  justify-content: center;
}
.mazda-styles.browse-vechicles-img a img {
  height: 40px;
  margin: 0 auto 10px;
}

@media (max-width: 1199px) {
  .browse-vechicles-img .vehicle-browse-ajax img {
    max-height: 60px;
  }
}

@media (min-width: 992px) {
  .browse-vechicles-img .col-md-3.col-sm-6.col-xs-6 {
    border-right: 1px solid #aaa;
  }
}

@media (max-width: 991px) {
   .browse-vechicles-img .col-md-3.col-sm-6.col-xs-6:nth-of-type(odd) {
      border-right: 1px solid #aaa;
   } 
}

@media (max-width: 767px) {
  .browse-vechicles-img .vehicle-browse-ajax img {
    max-height: 50px;
  }
  .browse-vechicles-img a {
    display: block;
  }
}

@media (max-width: 575px) {
  .mazda-styles.browse-vechicles-img .col-md-3.col-sm-6.col-xs-6 {
    width: 100%;
  }
}
</style>
